import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useAndroidBackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        let isCapacitor = false;
        let backButtonListener = null;

        const initializeBackButtonHandler = async () => {
            try {
                // Check if we're in Capacitor
                const { Capacitor } = await import('@capacitor/core');
                isCapacitor = Capacitor.isNativePlatform();

                if (isCapacitor) {
                    const { App } = await import('@capacitor/app');
                    
                    // Handle back button on login page for Android Capacitor only
                    if (location.pathname === '/login') {
                        backButtonListener = await App.addListener('backButton', () => {
                            // If user came from a protected route, go back to where they were before the protected page
                            if (location.state?.redirectTo) {
                                // Go back 2 pages to skip the protected page and intermediate login page
                                window.history.go(-2);
                            } else {
                                // Otherwise, try to go back in history
                                navigate(-1);
                            }
                        });
                    }
                }
            } catch (error) {
                console.log('Capacitor App plugin not available:', error);
            }
        };

        initializeBackButtonHandler();

        return () => {
            if (backButtonListener) {
                backButtonListener.remove();
            }
        };
    }, [location.pathname, location.state, navigate]);
}; 